import { type FC, type ReactNode } from 'react'

type ProductPriceExplainerSectionProps = {
  children: ReactNode
  headingIcon?: ReactNode
  headingId?: string
  headingText?: ReactNode
}

export const ProductPriceExplainerSection: FC<
  ProductPriceExplainerSectionProps
> = ({ children, headingIcon, headingId, headingText }) => {
  return (
    <section
      aria-labelledby={headingId}
      className="rounded-l bg-light-primary-low p-4"
    >
      {headingText ? (
        <h2 className="mb-4 flex gap-2 text-xl font-medium" id={headingId}>
          {headingIcon ? (
            <div className="self-start rounded-full bg-light-brand-medium p-1.5">
              {headingIcon}
            </div>
          ) : null}
          {headingText}
        </h2>
      ) : null}

      <div className="flex flex-col gap-4 text-s">{children}</div>
    </section>
  )
}
